import styled from '@emotion/styled';

import { authColors, authLayout } from 'design-system/tokens';

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 128px;
  max-height: 128px;
  padding: 32px;
  background: ${authColors.white};

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    justify-content: flex-start;
    padding: 40px 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  width: 100%;
  max-width: ${authLayout.contentWidth};
`;

export const Logo = styled.img`
  width: 155px;
  height: 38px;

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    width: 138px;
    height: auto;
  }
`;
